import './App.css';
import Hero from './components/Hero';
import MembershipCards from './components/MembershipCards';
import Hosts from './components/Hosts';
import HowItWorks from './components/HowItWorks';
import FromBriefingToPartnership from './components/FromBriefingToPartnership';
import Directory from './components/Directory';
import SponsoredSignalSystem from './components/SponsoredSignalSystem';
import Bonus from './components/Bonus';
import Comparison from './components/Comparison';
import Boundary from './components/Boundary';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Hero />
      <MembershipCards />
      <Hosts />
      <HowItWorks />
      <FromBriefingToPartnership />
      <Directory />
      <SponsoredSignalSystem />
      <Bonus />
      <Comparison />
      <Boundary />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;